/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { SetContactMonitoringMutationRequest, SetContactMonitoringMutationResponse, SetContactMonitoringPathParams, SetContactMonitoringHeaderParams, SetContactMonitoring401 } from "../../models/contactsController/SetContactMonitoring";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const setContactMonitoringMutationKey = () => [{ url: '/contacts/:contactId/monitoring' }] as const

export type SetContactMonitoringMutationKey = ReturnType<typeof setContactMonitoringMutationKey>

/**
 * {@link /contacts/:contactId/monitoring}
 */
export async function setContactMonitoring(contactId: SetContactMonitoringPathParams["contactId"], data: SetContactMonitoringMutationRequest, headers?: SetContactMonitoringHeaderParams, config: Partial<RequestConfig<SetContactMonitoringMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SetContactMonitoringMutationResponse, ResponseErrorConfig<SetContactMonitoring401>, SetContactMonitoringMutationRequest>({ method : "PATCH", url : `/contacts/${contactId}/monitoring`, data : requestData, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function setContactMonitoringMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SetContactMonitoringMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = setContactMonitoringMutationKey()
        return mutationOptions<SetContactMonitoringMutationResponse, ResponseErrorConfig<SetContactMonitoring401>, {contactId: SetContactMonitoringPathParams["contactId"], data: SetContactMonitoringMutationRequest, headers?: SetContactMonitoringHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ contactId, data, headers }) => {
            return setContactMonitoring(contactId, data, headers, config)
          },
        })

}

/**
 * {@link /contacts/:contactId/monitoring}
 */
export function useSetContactMonitoring<TContext>(options: 
{
  mutation?: UseMutationOptions<SetContactMonitoringMutationResponse, ResponseErrorConfig<SetContactMonitoring401>, {contactId: SetContactMonitoringPathParams["contactId"], data: SetContactMonitoringMutationRequest, headers?: SetContactMonitoringHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SetContactMonitoringMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? setContactMonitoringMutationKey()

          const baseOptions = setContactMonitoringMutationOptions(config) as UseMutationOptions<SetContactMonitoringMutationResponse, ResponseErrorConfig<SetContactMonitoring401>, {contactId: SetContactMonitoringPathParams["contactId"], data: SetContactMonitoringMutationRequest, headers?: SetContactMonitoringHeaderParams}, TContext>
          

          return useMutation<SetContactMonitoringMutationResponse, ResponseErrorConfig<SetContactMonitoring401>, {contactId: SetContactMonitoringPathParams["contactId"], data: SetContactMonitoringMutationRequest, headers?: SetContactMonitoringHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SetContactMonitoringMutationResponse, ResponseErrorConfig<SetContactMonitoring401>, {contactId: SetContactMonitoringPathParams["contactId"], data: SetContactMonitoringMutationRequest, headers?: SetContactMonitoringHeaderParams}, TContext>
      
}